/* eslint-disable max-lines */
import { usePropertyStore } from "@components/SearchResults/store/propertyStore"
import CustomSelect from "@components/elements/CustomSelect/CustomSelect"
import SearchIcon from "@components/icons/SearchIcon"
import useDeviceMedia from "@hooks/useDeviceMedia"
import {
  addTraillingSlash,
  formatCurrencyOption,
  getAreaPath,
  getBedroomPath,
  //   getBedroomPath,
  getPricePath,
  // getProppertyTypePath,
  getSizePath,
  updatePropertyTypePath,
} from "@lib/searchUtils"
import clsx from "clsx"
import { navigate } from "gatsby"
import React, { useEffect } from "react"
import Slider from "react-slick"
import { useGlobalStore } from "@stores/globalStore"
import { isEmpty } from "lodash"
import {
  commercialPropertyTypeOptions,
  maxAreaSizeOptions,
  maxBedroomOptions,
  maxPriceOptionsResiRent,
  maxPriceOptionsResiSale,
  minAreaSizeOptions,
  minBedroomOptions,
  minPriceOptionsResiRent,
  minPriceOptionsResiSale,
  resiPropertyTypeOptions,
} from "../../filterOptions"
import MultiSelectInput from "@components/SearchResults/MultiSelectInput/MultiSelectInput"
import { Modal } from "react-bootstrap"
import { AreaSlider } from "../../filterElements"

const FilterModalBody = ({ setIsOpen, buyRent, isOffPlan }) => {
  const { currencyType } = useGlobalStore()
  const {
    maxPrice,
    setMaxPrice,
    minPrice,
    setMinPrice,
    maxPriceOptions,
    minPriceOptions,
    setMinPriceOptions,
    setMaxPriceOptions,
  } = usePropertyStore((state) => ({
    minPrice: state.minPrice,
    setMinPrice: state.setMinPrice,
    maxPrice: state.maxPrice,
    setMaxPrice: state.setMaxPrice,
    maxPriceOptions: state.maxPriceOptions,
    minPriceOptions: state.minPriceOptions,
    setMinPriceOptions: state.setMinPriceOptions,
    setMaxPriceOptions: state.setMaxPriceOptions,
  }))
  //   const [department, setDepartment] = React.useState()
  // const [minPriceOptions, setMinPriceOptions] = React.useState([])
  // const [minPrice, setMinPrice] = React.useState()
  // const [maxPriceOptions, setMaxPriceOptions] = React.useState([])
  // const [maxPrice, setMaxPrice] = React.useState()
  const [minBedrooms, setMinBedrooms] = React.useState()
  const [maxBedrooms, setMaxBedrooms] = React.useState()
  const [minBedroomsOptions, setMinBedroomsOptions] = React.useState([])
  const [maxBedroomsOptions, setMaxBedroomsOptions] = React.useState([])
  // const [minAreaSize, setMinAreaSize] = React.useState()
  // const [maxAreaSize, setMaxAreaSize] = React.useState()
  const {minAreaSize, maxAreaSize} = usePropertyStore()

  const [maxAreaOptions, setMaxAreaOptions] = React.useState([])
  const [minAreaOptions, setMinAreaOptions] = React.useState([])
  const [propertyType, setPropertyType] = React.useState()
  const [propertyTypeOptions, setPropertyTypeOptions] = React.useState([])

  const selectedAreas = usePropertyStore((state) => state.selectedAreas)

  const { isTablet } = useDeviceMedia()

  const isLettings = false

  const clearFilters = () => {
    const minPriceOptionsFirstRender = isLettings
      ? minPriceOptionsResiRent
      : minPriceOptionsResiSale

    const maxPriceOptionsFirstRender = isLettings
      ? maxPriceOptionsResiRent
      : maxPriceOptionsResiSale

    const propertyTypeOptionsFirstRender = false
      ? commercialPropertyTypeOptions
      : resiPropertyTypeOptions

    // setDepartment("residential")

    setMinPriceOptions(minPriceOptionsFirstRender)
    setMaxPriceOptions(maxPriceOptionsFirstRender)
    setPropertyTypeOptions(propertyTypeOptionsFirstRender)
    setMinAreaOptions(minAreaSizeOptions)
    setMaxAreaOptions(maxAreaSizeOptions)
    setMinBedroomsOptions(minBedroomOptions)
    setMaxBedroomsOptions(maxBedroomOptions)

    setMinPrice(minPriceOptionsFirstRender[0])
    setMaxPrice(maxPriceOptionsFirstRender[0])
    setPropertyType(propertyTypeOptionsFirstRender[0])
    // setMinAreaSize(minAreaSizeOptions[0])
    // setMaxAreaSize(maxAreaSizeOptions[0])
    setMinBedrooms(minBedroomOptions[0])
    setMaxBedrooms(maxBedroomOptions[0])
  }
  useEffect(() => {
    const convertedMinPriceOptions = minPriceOptions?.map((option) =>
      formatCurrencyOption({ option, currencyType })
    )

    if (!isEmpty(convertedMinPriceOptions))
      setMinPriceOptions(convertedMinPriceOptions)

    const convertedMaxPriceOptions = maxPriceOptions?.map((option) =>
      formatCurrencyOption({ option, currencyType })
    )

    if (!isEmpty(convertedMaxPriceOptions))
      setMaxPriceOptions(convertedMaxPriceOptions)
    // const convertedMaxPrice = {
    //   label:
    //     maxPrice?.value === ""
    //       ? maxPrice?.label
    //       : `${currencyType.label} ${parseInt(
    //           calcPrice(maxPrice?.value, currencyType.value, "AED")
    //         ).toLocaleString("en-US")}`,
    //   value: maxPrice?.value,
    // }

    // if (!isEmpty(convertedMaxPrice)) setMaxPrice(convertedMaxPrice)
  }, [maxPrice, minPrice])

  // on min price change
  useEffect(() => {
    if (!minPrice) return

    const convertedMaxPriceOptions = maxPriceOptions?.map((option) =>
      formatCurrencyOption({ option, currencyType })
    )

    if (!isEmpty(convertedMaxPriceOptions))
      setMaxPriceOptions(convertedMaxPriceOptions)

    // setMaxPriceOptions(
    //   maxPriceOptions.filter(
    //     (priceOption) =>
    //       !priceOption.value ||
    //       !minPrice.value ||
    //       Number(priceOption.value) > Number(minPrice.value)
    //   )
    // )
  }, [minPrice])

  // on max price change
  useEffect(() => {
    if (!maxPrice) return

    const convertedMinPriceOptions = minPriceOptions?.map((option) =>
      formatCurrencyOption({ option, currencyType })
    )

    if (!isEmpty(convertedMinPriceOptions))
      setMinPriceOptions(convertedMinPriceOptions)

    // setMinPriceOptions(
    //   minPriceOptions.filter(
    //     (priceOption) =>
    //       !priceOption.value ||
    //       !maxPrice.value ||
    //       Number(priceOption.value) < Number(maxPrice.value)
    //   )
    // )
  }, [maxPrice])
  React.useEffect(() => {
    clearFilters()
  }, [])

  const submitSearch = () => {
    let url = `${buyRent?.value}/`

    url += getAreaPath(selectedAreas)
    // url += getProppertyTypePath(propertyType?.value)
    url = updatePropertyTypePath(propertyType?.value, url)
    url += getPricePath(minPrice?.value, maxPrice?.value)
    url += getBedroomPath(minBedrooms?.value, maxBedrooms?.value)
    url += getSizePath(minAreaSize?.value, maxAreaSize?.value)

    navigate(addTraillingSlash(url))
    // window.location.href = addTraillingSlash(url)
        // url = addTraillingSlash(url)
        // window.location.href = url
        // window.location.replace(url)
    setIsOpen(false)
  }

  const settings = {
    swipeToSlide: true,
    variableWidth: true,
    infinite: false,
  }

  const onMinPriceChange = (option) => {
    setMinPrice(option)

    const _maxPriceOptions = isLettings
      ? maxPriceOptionsResiRent
      : maxPriceOptionsResiSale

    setMaxPriceOptions(
      _maxPriceOptions.filter(
        (priceOption) =>
          Number(priceOption.value) > Number(option.value) ||
          !priceOption.value ||
          !option.value
      )
    )
  }

  const onMaxPriceChange = (option) => {
    setMaxPrice(option)

    const _minPriceOptions = isLettings
      ? minPriceOptionsResiRent
      : minPriceOptionsResiSale

    setMinPriceOptions(
      _minPriceOptions.filter(
        (priceOption) =>
          Number(priceOption.value) < Number(option.value) ||
          !priceOption.value ||
          !option.value
      )
    )
  }

  const onMinBedroomsChange = (option) => {
    setMinBedrooms(option)

    setMaxBedroomsOptions(
      maxBedroomOptions.filter(
        (bedroomOption) =>
          Number(bedroomOption.value) >= Number(option.value) ||
          !bedroomOption.value ||
          !option.value
      )
    )
  }

  const onMaxBedroomsChange = (option) => {
    setMaxBedrooms(option)

    setMinBedroomsOptions(
      minBedroomOptions.filter(
        (bedroomOption) =>
          Number(bedroomOption.value) <= Number(option.value) ||
          !bedroomOption.value ||
          !option.value
      )
    )
  }

  // const onMinAreaSizeChange = (option) => {
  //   setMinAreaSize(option)

  //   setMaxAreaOptions(
  //     maxAreaSizeOptions.filter(
  //       (areaOption) =>
  //         Number(areaOption.value) > Number(option.value) ||
  //         !areaOption.value ||
  //         !option.value
  //     )
  //   )
  // }

  // const onMaxAreaSizeChange = (option) => {
  //   setMaxAreaSize(option)

  //   setMinAreaOptions(
  //     minAreaSizeOptions.filter(
  //       (areaOption) =>
  //         Number(areaOption.value) < Number(option.value) ||
  //         !areaOption.value ||
  //         !option.value
  //     )
  //   )
  // }

  return (
   <>
      <Modal.Body>
      <div className="filter-section">
      {isTablet ? (
        <div className="modal-filter-item building-type-select">
          <h3 className="modal-filter-title">Location</h3>
          <div className="modal-filter-section">
          <MultiSelectInput setIsModalOpen={setIsOpen} isOffPlan={isOffPlan} />
          </div>
          <div className="divider" />
          <h3 className="modal-filter-title">Property Type</h3>
          <div className="modal-filter-section selection-section">
            <Slider {...settings}>
              {propertyTypeOptions.map((option) => (
                <div
                  className="selection-item-wrap"
                  key={`${option.value}building-type`}
                >
                  <div
                    className={clsx(
                      "selection-item",
                      propertyType === option && "active"
                    )}
                    onClick={() => setPropertyType(option)}
                  >
                    {option.label}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      ) : (
        <div className="modal-filter-item range-select type-status-select">
          <h3 className="modal-filter-title">Type & Status</h3>
          <div className="modal-filter-section">
            <CustomSelect
              options={propertyTypeOptions}
              value={propertyType}
              onChange={setPropertyType}
              className="filter-select min-price-select"
            />
            <CustomSelect
              options={maxPriceOptions}
              value={maxPrice}
              onChange={setMaxPrice}
              className="filter-select max-price-select invisible"
            />
          </div>
        </div>
      )}
      <div className="divider" />
      <div className="modal-filter-item range-select price-range-select">
        <h3 className="modal-filter-title">Price Range</h3>
        <div className="modal-filter-section">
          <CustomSelect
            options={minPriceOptions}
            value={minPrice}
            onChange={onMinPriceChange}
            className="filter-select min-price-select"
          />
          <CustomSelect
            options={maxPriceOptions}
            value={maxPrice}
            onChange={onMaxPriceChange}
            className="filter-select max-price-select"
          />
        </div>
      </div>
      <div className="divider" />

      <div className="modal-filter-item range-select bedroom-range-select">
        <h3 className="modal-filter-title">Bedrooms</h3>
        <div className="modal-filter-section">
          <CustomSelect
            options={minBedroomsOptions}
            value={minBedrooms}
            onChange={onMinBedroomsChange}
            className="filter-select min-bedroom-select"
          />
          <CustomSelect
            options={maxBedroomsOptions}
            value={maxBedrooms}
            onChange={onMaxBedroomsChange}
            className="filter-select max-bedroom-select"
          />
        </div>
      </div>
      <div className="divider" />

      <div className="modal-filter-item range-select area-range-select">
        <h3 className="modal-filter-title">Size</h3>
        <div className="modal-filter-item range-select area-range-select">
                      <AreaSlider />
                    </div>
      </div>
      </div>
      {/* <div className="divider" /> */}
</Modal.Body>
<Modal.Footer>
      {/* {isCommercial ? <AreaSizeSelect /> : <BedroomSelect />} */}
      <div className="cta-section">
        <button className="button button-gray" onClick={clearFilters}>
          Clear Filters
        </button>
        <button className="button button-orange" onClick={submitSearch}>
          <span>Search</span>
          <SearchIcon color="white" />
        </button>
      </div>
      </Modal.Footer>
    </>
  )
}

export default FilterModalBody
